import {Feature, Features} from "../feature";
import {extractorUtil} from "../util/extractorUtil";

export const inRingFilter = {
    filterInPlace: (features: Feature[]) => {
        // Connection points for features in a ring are the ring atoms where the feature is rooted.
        const rings = features.filter((feature: Feature) => feature.name.includes(Features.ring))
        const amines = features.filter((feature: Feature) => feature.name.includes(Features.amine))
        rings.forEach((ring: Feature) => {
            const featuresInRing = amines.filter(feature => extractorUtil.areHeavyAtomsInRing(feature.atoms, ring.atoms))
            if(featuresInRing.length > 0) {
                featuresInRing.forEach(feature => {
                    feature.connections = feature.atoms.filter(ringAtom => ring.atoms.includes(ringAtom))
                })
            }
        })

        // PIPH-58 item 8: drop alkene features whose atoms are entirely contained within
        // an aromatic (benzene) ring. The aromatic π system is already represented by the
        // benzene feature; reporting individual C=C bonds inside it is noise.
        const benzeneRings = features.filter(f => f.name.includes(Features.benzene));
        if (benzeneRings.length > 0) {
            for (let i = features.length - 1; i >= 0; i--) {
                const f = features[i];
                if (f.name !== Features.alkene) continue;
                const insideBenzene = benzeneRings.some(ring =>
                    extractorUtil.areHeavyAtomsInRing(f.atoms, ring.atoms)
                );
                if (insideBenzene) {
                    features.splice(i, 1);
                }
            }
        }

        return features;
    }
}